<template>
  <div class="app-container">
    <span style="font-size:18px;font-weight:bold">数据统计</span>
    <hr style="margin-top: 5px;border:1px solid #bababa" />
    <div style="margin-top: 20px;">
      开启状态：<span style="color:#ff0000">{{ total.start }}</span>
      <span style="margin-left:30px">移动状态：</span>
      <span style="color:#ff0000">{{ total.move }}</span>
      <span style="margin-left:30px">结束状态：</span>
      <span style="color:#ff0000">{{ total.stop }}</span>

      <el-date-picker style="float: right; margin-right: 2%;" v-model="listQuery.time" type="daterange" align="right" unlink-panels
        range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" @change="setTableData">
      </el-date-picker>

    </div>

    <!-- 数据列表区 -->
    <el-table :data="tableData" style="width: 100%; margin:0 auto;align: center; margin-top:30px;" border
      :header-cell-style="tableHeaderColor" highlight-current-row>
      <el-table-column prop="days" label="日期" width="180" align="center" header-align="center">
        <template slot-scope="scope">{{scope.row.days| dateYMDHFormat}}</template>
      </el-table-column>
      <el-table-column prop="sendCount" label="发送报文条数" width="180" align="center" header-align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.sendCount === null">0</span>
          <span v-else>{{scope.row.sendCount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="failCount" label="未回复报文条数" width="200" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.failCount === null">0</span>
          <span v-else>{{scope.row.failCount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sendSum" label="发送总字节数" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.sendSum === null">0</span>
          <span v-else>{{scope.row.sendSum}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="receiveSum" label="收到总字节数" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.receiveSum === null">0</span>
          <span v-else>{{scope.row.receiveSum}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="intervalMax" label="收到回复最长间隔" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.intervalMax === null">0</span>
          <span v-else>{{scope.row.intervalMax}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="intervalMin" label="收到回复最短间隔" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.intervalMin === null">0</span>
          <span v-else>{{scope.row.intervalMin}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="intervalAvg" label="收到回复平均间隔" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.intervalAvg === null">0</span>
          <span v-else>{{scope.row.intervalAvg}}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页栏 -->
    <pagination-easy :total="totalCount" @pagination="handlePageChangeCar" layout='prev, pager, next, jumper'
      :page="listQuery.pageIndex" small :pager-count="5">
    </pagination-easy>


    <div>

      <bottom-left style="margin-top: 40px; display: inline-block" :record="tableData"></bottom-left>

      <bottom-right style="margin-top: 40px; margin-left: 100px;display: inline-block" :record="tableData"></bottom-right>

    </div>

    <buttom-down style="margin-top: 40px;" :record="tableData"></buttom-down>
    <!-- <div id="bottomLeft">
      <div class="bg-color-black">
        <div class="d-flex pt-2 pl-2">
          <span style="color:#5cd9e8">
            <icon name="chart-bar"></icon>
          </span>
          <div class="d-flex">
            <span class="fs-xl text mx-2">在线时间统计图</span>
          </div>
        </div>
        <div>
          <BottomLeftChart :carId="carId" :theme="theme" />
        </div>
      </div>
    </div> -->


  </div>

</template>

<script>
  import paginationEasy from '@/components/common/Pagination'
  import bottomLeft from '@/components/echart/bottom/bottomLeft'
  import bottomRight from '@/components/echart/bottom/bottomRight'
  import buttomDown from '@/components/echart/bottom/buttomDown'
  import {
    totalList
  } from '@/api/car'

  export default {

    components: {
      paginationEasy,
      bottomLeft,
      bottomRight,
      buttomDown
    },

    data() {
      return {

        // 数量总和
        totalCount: 30,

        listQuery: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          params: {
            car_id: undefined,
            lesseeName: undefined,
            order_type: undefined,
          },
          fuzzySearch: true,
          time: [undefined, undefined],
        },

        total: {
          start: 0,
          stop: 0,
          move: 0,
        },

        /* 快捷时间 */
        /* pickerOptions: {
        	shortcuts: [{
        		text: '最近一周',
        		onClick(picker) {
        		const end = new Date();
        		const start = new Date();
        		start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        		picker.$emit('pick', [start, end]);
        		}
        	}, {
        		text: '最近一个月',
        		onClick(picker) {
        		const end = new Date();
        		const start = new Date();
        		start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        		picker.$emit('pick', [start, end]);
        		}
        	}, {
        		text: '最近三个月',
        		onClick(picker) {
        		const end = new Date();
        		const start = new Date();
        		start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        		picker.$emit('pick', [start, end]);
        		}
        	}]
        }, */
        carTypeDialogVisable: false,
        carTypeDialogVisableCreate: false,
        enbleSelect: true,

        dialogTitleType: 'create',

        tableHeight: '',

        // 列表数据
        tableData: [],

      }
    },
    filters: {

    },
    created() {
      //  this.tableHeight = window.innerHeight - 500
    },
    methods: { // 修改table tr行的背景色
      tableRowStyle({
        row,
        rowIndex
      }) {
        return 'background-color: #f9f8ff'
      },

      // 修改table header的背景色
      tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (rowIndex === 0) {
          return 'background-color: #e8e8e8;color: #000000;font-weight: 500;'
        }
      },

      /**
       * 处理列表翻页
       * @param {Object} data
       */
      handlePageChangeCar(data) {
        console.log("当前页", data);
        this.listQuery.pageIndex = data.page
        this.listQuery.pageSize = data.limit
        this.setTableData();
      },


      setTableData() {

        // console.log(this.listQuery);
        if (this.listQuery.time[0] != null && this.listQuery.time[1] != null) {
          this.listQuery.time[0] = this.dateFormat("YYYY-mm-dd", new Date(this.listQuery.time[0]));
          this.listQuery.time[1] = this.dateFormat("YYYY-mm-dd", new Date(this.listQuery.time[1]));

        }

        totalList(this.listQuery).then(res => {

          console.log(res);
          if (res.result == '1') {

            this.tableData = res.data;
            this.total = res.total;
            this.totalCount = res.pageModel.totalRecord;
          }

        })

      },

      // 格式化日期
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString() // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },

    }, // methods

    mounted() {
      this.setTableData();
    }

  }
</script>

<style>
  .pagination_easy {
    margin-top: 20px;
    /* margin-left: 10px; */
  }

  /* // 去掉横线 */
  .el-table__row>td {
    border: none;
  }

  .btn-car {
    background-color: #cbcbcb;
    border: none;
  }

  .btn-car-del {
    background-color: #bea1a1;
    border: none;
  }

  #bottomLeft {
    padding: 0.3rem 0.2rem;
    height: 3.5rem;
    min-width: 3.75rem;
    border-radius: 0.0625rem;

    .bg-color-black {
      height: 3rem;
      border-radius: 0.125rem;
    }

    .text {
      color: #c3cbde;
    }

    .chart-box {
      margin-top: 0.2rem;
      width: 2.125rem;
      height: 2.125rem;

      .active-ring-name {
        padding-top: 0.125rem;
      }
    }
  }

  /* 去掉最下面的那一条线
  .el-table::before {
  	height: 0px;
  } */
</style>
